export enum Theme {
  LIGHT = "lightTheme",
  DARK = "darkTheme",
}
